import {FC, useState, useEffect, useContext} from 'react'
import {useTranslation} from 'react-i18next'
import {ILanguage} from '../../types/common'
import YearMonthPicker from '../../common/YearMonthPicker'
import axios from 'axios'
import InfoBox from '../../common/InfoBox'
import {SessionContext, SessionContextType} from '../../common/ctx/SessionContext'

const FiltersOFE: FC<{
    language: ILanguage
    ctx: any
}> = ({language, ctx}) => {
    const {t} = useTranslation()
    const sessionCtx: SessionContextType = useContext(SessionContext)
    const [excludedDays, setExcludedDays] = useState<Array<Date>>()
    const [selectedDate, setSelectedDate] = useState<Date | undefined>()
    const [datePickerMinDate, setDatePickerMinDate] = useState<Date | undefined>()
    const [datePickerMaxDate, setDatePickerMaxDate] = useState<Date | undefined>()

    const [companyKrs, setCompanyKrs] = useState<string>()
    const [unitName, setUnitName] = useState<string>()
    const [unitValue, setUnitValue] = useState<number>()
    const [unitCurrency, setUnitCurrency] = useState<string>()
    const [companyName, setCompanyName] = useState<string>()
    const [companyAddress, setCompanyAddress] = useState<string>()
    const [assetsDate, setAssetsDate] = useState<string>()
    const [assetsValue, setAssetsValue] = useState<number>()

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/api/profile/EALL1`, {
                headers: {
                    Accept: 'application/json',
                },
                auth: {
                    username: `${process.env.REACT_APP_API_USERNAME}`,
                    password: `${process.env.REACT_APP_API_PASSWORD}`,
                },
            })
            .then((result) => {
                const profile = result.data
                setAssetsDate(new Date(profile.assetsNetDate)?.toLocaleDateString('pl-PL'))
                setAssetsValue(profile.assetsNetValue)
                setCompanyKrs(profile.companyKrs)
                setCompanyAddress(profile.companyAddr)
                setCompanyName(profile.companyName)
                setUnitName(profile.name)
                setUnitValue(profile.valuation)
                setUnitCurrency(profile.valuationCurrency)
            })
            .catch((error) => {
                console.error(error)
            })
    }, [])

    useEffect(() => {
        ctx.isDefault()
    }, [])

    useEffect(() => {
        setDatePickerMaxDate(ctx.maxDate)
        setDatePickerMinDate(ctx.minDate)
    }, [ctx.minDate, ctx.maxDate])

    // useEffect(() => {
    //     setSelectedDate(ctx.today)
    // }, [ctx.today])

    useEffect(() => {
        setExcludedDays(ctx.holiday)
    }, [ctx.holiday])

    return (
        <>
            <section id="layout-ofe" className="flex">
                <div className="name-ofe flex">
                    <p className="title-paragraph">{t('label.catalog.ofe.assets.date')}</p>
                    <p className="value-paragraph">{assetsDate}&nbsp;</p>
                </div>
                <div className="name-ofe flex">
                    <p className="title-paragraph">{t('label.catalog.ofe.name')}</p>
                    <p className="value-paragraph">{unitName}&nbsp;</p>
                </div>
                <div className="name-ofe flex">
                    <p className="title-paragraph">{t('label.catalog.ofe.company.name')}</p>
                    <p className="value-paragraph">{companyName}&nbsp;</p>
                </div>
                <div className="name-ofe flex">
                    <p className="title-paragraph">{t('label.catalog.ofe.company.address')}</p>
                    <p className="value-paragraph">{companyAddress}&nbsp;</p>
                </div>
                <div className="name-ofe flex">
                    <p className="title-paragraph">{t('label.catalog.ofe.krs')}</p>
                    <p className="value-paragraph">KRS {companyKrs}&nbsp;</p>
                </div>
                <div className="name-ofe flex">
                    <p className="title-paragraph">{t('label.catalog.ofe.assets.value')}</p>
                    <p className="value-paragraph">
                        {assetsValue?.toLocaleString('pl-PL')} {unitCurrency}&nbsp;
                    </p>
                </div>
                <div className="name-ofe flex">
                    <p className="title-paragraph">{t('label.catalog.ofe.unit.value')}</p>
                    <p className="value-paragraph">
                        {unitValue?.toLocaleString('pl-PL')} {unitCurrency}&nbsp;
                    </p>
                </div>
            </section>
            <div id="container-toolbar" className="flex" style={{justifyContent: 'flex-start'}}>
                {sessionCtx?.getItem(ctx.STORAGE_KEY) !== 'hidden' && (
                    <InfoBox
                        title={
                            <span>
                                {' '}
                                {t('label.infobox.filters.save')} <br />
                                {t('label.infobox.filters.continue')}{' '}
                            </span>
                        }
                        onCloseCallback={() => {
                            sessionCtx.setItem(ctx.STORAGE_KEY, 'hidden')
                        }}
                    />
                )}
                <div className="filter-bar filter-bar-ofe flex">
                    <div className="up-filter-bar">
                        <div className="grid-column flex">
                            <div className="datepickers-item flex">
                                <label className="datepickers-item-label">{t('label.datepicker.title2')}</label>
                                <YearMonthPicker
                                    language={language}
                                    selectedDate={selectedDate}
                                    setSelectedDate={setSelectedDate}
                                    datePickerMinDate={datePickerMinDate}
                                    datePickerMaxDate={datePickerMaxDate}
                                    withCurrentDate={true}
                                    excludeDates={excludedDays}
                                    filterDate={(date) => {
                                        return date.getDay() !== 0 && date.getDay() !== 6
                                    }}
                                    onDateChangeCallback={(date) => {
                                        ctx.setDate(date)
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FiltersOFE
